export const FETCH_DATA = "FETCH_DATA";
